import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: function _default() {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapState({
    currency: function currency(state) {
      return state.user.company_info.currency;
    }
  })),
  mounted: function mounted() {},
  methods: {
    blurDeduction8: function blurDeduction8() {
      var val = Number(this.staffInfo.tax_deduction_8);
      if (val && val % 30000 !== 0) {
        this.$emit('clearDeduction', 'tax_deduction_8');
      }
    },
    blurDeduction10: function blurDeduction10() {
      this.$emit('blurDeduction10', this.staffInfo.tax_deduction_10);
    },
    blurDeduction11: function blurDeduction11() {
      this.$emit('blurDeduction11', this.staffInfo.tax_deduction_11);
    },
    blurDeduction13: function blurDeduction13() {
      this.$emit('blurDeduction13', this.staffInfo.tax_deduction_13);
    },
    blurDeduction14: function blurDeduction14() {
      this.$emit('blurDeduction14', this.staffInfo.tax_deduction_14);
    },
    blurDeduction17: function blurDeduction17() {
      var val = Number(this.staffInfo.tax_deduction_17);
      if (val && val % 60000 !== 0) {
        this.$emit('clearDeduction', 'tax_deduction_17');
      }
    },
    blurDeduction19: function blurDeduction19() {
      this.$emit('blurDeduction19', this.staffInfo.tax_deduction_19);
    }
  }
};